import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { AisReducer } from './ais.feature';
import { BenchmarkReducer } from './benchmark.feature';
import { ChecklistReducer } from './checklist.feature';
import { MOURIskReducer } from './mou-risk.feature';
import { PortCodeReducer } from './port-code.feature';
import { SubscriptionReducer } from './subscription.feature';
import { UserReducer } from './user.feature';
import { VesselReducer } from './vessel.feature';

export const store = configureStore({
    reducer: {
        User: UserReducer,
        Vessel: VesselReducer,
        Ais: AisReducer,
        PortCode: PortCodeReducer,
        MOURisk: MOURIskReducer,
        Subscription: SubscriptionReducer,
        Checklist: ChecklistReducer,
        Benchmark: BenchmarkReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['checklist/GeneratePdfChecklist/fulfilled', 'checklist/GeneratePdfChecklist/rejected'],
                ignoredPaths: ['Checklist.pdfBlob']
            }
        })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Define the useAppSelector hook
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
